import { Nullable } from '@clearverify/types';

import { EmployeeWhere, PositionWhere, QueryMode } from 'src/api';
import { gql } from 'src/utils/gql';

export function getEmployeeFilterManager(searchValue: Nullable<string>): EmployeeWhere {
  return gql.wrapToOR([getSsnFilter(searchValue), getPositionsEmployeeIdFilter(searchValue)]);
}

export function getEmployeeWithLatestPositionFilter(searchValue: Nullable<string>): PositionWhere {
  if (!searchValue) return {};

  return {
    OR: [
      { extEmployeeId: { contains: searchValue, mode: QueryMode.Insensitive } },
      { employee: { ssn: { equals: sanitizeSsn(searchValue) } } },
    ],
  };
}

export function getEmployeeWithLatestPositionSsnOnlyFilter(
  searchValue: Nullable<string>,
): PositionWhere {
  if (!searchValue) return {};

  return {
    employee: {
      ssn: { equals: sanitizeSsn(searchValue) },
    },
  };
}

function getSsnFilter(searchValue: Nullable<string>) {
  return {
    ssn: {
      equals: sanitizeSsn(searchValue),
    },
  };
}

function getPositionsEmployeeIdFilter(searchValue: Nullable<string>): EmployeeWhere {
  return {
    positions: {
      some: {
        extEmployeeId: {
          equals: searchValue,
          mode: QueryMode.Insensitive,
        },
      },
    },
  };
}

function sanitizeSsn(ssn: Nullable<string>) {
  return ssn?.replace(/-/g, '');
}
